module.exports = __webpack_public_path__ + "img/TV_Adverts_image_1.96be298c.jpg";